import script from "./DisplayUsers.vue?vue&type=script&setup=true&lang=js"
export * from "./DisplayUsers.vue?vue&type=script&setup=true&lang=js"

import "./DisplayUsers.vue?vue&type=style&index=0&id=ab998804&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ab998804"]])

export default __exports__